module.exports = require("../../../lib").google.protobuf;
